module.exports = __webpack_public_path__ + "static/media/body-facilities.1804e4d8.jpg";